import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient, ConvertParamsToFormData } from "~/utils";

import {
  ApiManagersRoleplayingConditionMutateType,
  RawDraftContentState,
} from "~/domains";

type RequestDataType = {
  body: {
    title: string;
    content: RawDraftContentState;
    postDate: string;
    roleplayingConditionTemplateId?: string;
    attachFiles?: File[];
    participationEmployeeIds: string[];
    businessSectionIds: string[];
  };
};

const request = ({ body }: RequestDataType) => {
  const formData = ConvertParamsToFormData({ roleplayingCondition: body });
  return new ApiClient()
    .post<ApiManagersRoleplayingConditionMutateType>(
      "/api/managers/roleplaying_conditions",
      formData,
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisManagersRoleplayingConditionsCreate = ({
  options = {},
}: PropsType = {}): UseMutationResult<
  ApiManagersRoleplayingConditionMutateType,
  RequestDataType
> => {
  return useMutation(request, { ...options });
};
